import { candidateName } from "./candidateName";
import { CONTRACT_STATUSES } from "./contractStatus";

export function mouradPlanningContracts(candidate) {
  if (
    candidate &&
    candidateName(candidate).toLocaleUpperCase("fr-FR") !== "MOURAD ALIOUACHENE"
  )
    return [];
  const periods = [
    [
      "20261008",
      "20261009",
      "0800",
      "1600",
      "Entrepôt de démonstration",
      "Préparateur de commandes",
    ],
    [
      "20261012",
      "20261016",
      "1400",
      "2200",
      "Atelier de démonstration",
      "Agent de production",
    ],
    [
      "20261026",
      "20261103",
      "0900",
      "1700",
      "Services de démonstration",
      "Agent polyvalent",
    ],
  ];
  const examples = periods.map(
    (
      [DateDebut, DateFin, HeureDebut, HeureFin, RaisonSociale, Qualification],
      index,
    ) => ({
      _id: `demo-mourad-planning-${index + 1}`,
      isDemo: true,
      NumeroContrat: `TEST-MOURAD-${String(index + 1).padStart(3, "0")}`,
      NomPrenom: "Mourad ALIOUACHENE",
      ...(candidate?.pld != null ? { IdInterimaire: candidate.pld } : {}),
      DateDebut,
      DateFin,
      HeureDebut,
      HeureFin,
      RaisonSociale,
      Qualification,
      TxtQualification: Qualification,
      AdresseVille: "Site de démonstration",
      createdAt: "2026-10-08T09:00:00+02:00",
      statut: CONTRACT_STATUSES.unsigned,
    }),
  );
  return [...examples, ...savedMouradDuplicates()];
}

const duplicateKey = () =>
  `jm-mourad-demo-duplicates:${localStorage.getItem("userId")}:${localStorage.getItem("agencyName")}`;
function savedMouradDuplicates() {
  try {
    const data = JSON.parse(localStorage.getItem(duplicateKey()));
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
}
export function saveMouradDuplicate(source, candidate, payload) {
  const id = crypto.randomUUID();
  const copy = {
    ...source,
    _id: `demo-mourad-copy-${id}`,
    NumeroContrat: `TEST-MOURAD-DUP-${id.slice(0, 8).toUpperCase()}`,
    DateDebut: payload.startDateString,
    DateFin: payload.endDateString || payload.startDateString,
    DateFinMission: payload.endDateString || payload.startDateString,
    HeureDebut: payload.startHourString,
    HeureFin: payload.endHourString,
    createdAt: new Date().toISOString(),
    isDemo: true,
  };
  localStorage.setItem(
    duplicateKey(),
    JSON.stringify([...savedMouradDuplicates(), copy]),
  );
  return copy;
}
